import { trending } from '@/mocks/content';

const trendIcon = (trend: string) => {
  if (trend === 'up') return { icon: 'ri-arrow-up-line', cls: 'text-primary-600' };
  if (trend === 'down') return { icon: 'ri-arrow-down-line', cls: 'text-foreground-500' };
  return { icon: 'ri-subtract-line', cls: 'text-foreground-400' };
};

export default function TrendingSection() {
  return (
    <section id="trending" className="scroll-mt-nav py-12 md:py-16 bg-background-100/60">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-end justify-between gap-4 flex-wrap">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 flex items-center gap-2">
                <i className="ri-fire-line text-primary-500"></i>
                本周热门榜
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                按近期浏览热度排序，帮你快速跟上看当前大家都在关注什么。
              </p>
            </div>
            <span className="text-xs text-foreground-500">数据按综合热度估算，仅供参考</span>
          </div>

          <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
            {trending.map((item) => {
              const t = trendIcon(item.trend);
              return (
                <a
                  key={item.rank}
                  href="#collections"
                  className="group flex items-center gap-3 md:gap-4 p-3 rounded-lg bg-background-50 border border-background-200 cursor-pointer transition-colors hover:border-primary-300"
                >
                  <span
                    className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-md font-heading font-bold text-sm ${
                      item.rank <= 3
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="w-20 h-14 md:w-24 md:h-[60px] flex-shrink-0 rounded-md overflow-hidden">
                    <img
                      src={item.cover}
                      alt={`${item.title} 缩略封面`}
                      title={`${item.title} - 91精选热门`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="text-sm font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
                      {item.title}
                    </h3>
                    <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-600">
                      <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">
                        {item.categoryName}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-fire-line text-primary-500"></i>
                        {item.heat}
                      </span>
                    </div>
                  </div>
                  <i className={`${t.icon} ${t.cls} text-lg flex-shrink-0`}></i>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}